import React from "react";

const Hidden = ({ register, value, name }) => (
  <input type="hidden" {...register(name, { value: value })} />
);

export default Hidden;
